import { Shield, Zap, HeadphonesIcon, Lock, Globe2, RefreshCw, CreditCard, Award } from 'lucide-react';

export default function Features() {
  const features = [
    {
      icon: Shield,
      title: 'Free WHOIS Privacy',
      description: 'Protect your personal information from public WHOIS databases with our free privacy protection.',
    },
    {
      icon: CreditCard,
      title: 'At-Cost Pricing',
      description: 'No hidden fees or markups. You pay only the cheapest wholesale price set by domain registry.',
    },
    {
      icon: Zap,
      title: 'Fast DNS Propagation',
      description: 'Lightning-fast DNS updates ensure your domain is live within minutes, not hours.',
    },
    
    {
      icon: Globe2,
      title: 'Easy Management',
      description: 'Intuitive control panel for seamless domain management, DNS configuration, and more.',
    },
    {
      icon: Lock,
      title: 'SSL Certificates',
      description: "It's a secure namespace, SSL certificates needed with every domain to keep your visitors secure.",
    },
    {
      icon: RefreshCw,
      title: 'Auto-Renewal',
      description: 'Never lose your domain with optional automatic renewal and expiration reminders.',
    },
    {
      icon: Award,
      title: 'Domain Forwarding',
      description: 'Easily forward your domains to any URL with masking and path forwarding options.',
    },
    {
      icon: HeadphonesIcon,
      title: '24/7 Expert Support',
      description: 'Our knowledgeable support team is available around the clock to help you with any issues.',
    },
  ];

  return (
    <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-section-features">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-theme-primary mb-4">
            Why Choose com0.org?
          </h2>
          <p className="text-xl text-theme-secondary max-w-3xl mx-auto">
            Experience the perfect blend of trust, innovation, and value in domain registration
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="glass-card p-6 rounded-xl group"
            >
              <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-500/30 transition-colors">
                <feature.icon className="h-6 w-6 text-blue-500" />
              </div>
              <h3 className="text-lg font-semibold text-theme-primary mb-2">
                {feature.title}
              </h3>
              <p className="text-theme-secondary">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
